import { render, staticRenderFns } from "./DetailInventory.vue?vue&type=template&id=4352f5c6&"
import script from "./DetailInventory.vue?vue&type=script&lang=js&"
export * from "./DetailInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports